import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AccessibilityPreferencesService } from '../core/accessibility-preferences.service';
import { DsButtonDirective, DsCardDirective, DsCheckboxDirective } from '../ui';

@Component({
  selector: 'app-accessibility-page',
  imports: [DsButtonDirective, DsCardDirective, DsCheckboxDirective],
  templateUrl: './accessibility-page.html',
  styleUrl: './accessibility-page.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessibilityPage {
  protected readonly service = inject(AccessibilityPreferencesService);
  protected readonly preferences = this.service.preferences;
}
